import { makeStyles } from '@material-ui/core/styles'

export default makeStyles(theme => {
    let isUsingDarkScheme = false
    let isUsingSystemScheme = false
    try {
        isUsingDarkScheme = window.localStorage && localStorage.getItem('colorScheme') === 'dark'
        isUsingSystemScheme = window.localStorage && localStorage.getItem('colorScheme') === 'system'
    } catch (e) {
        // Local storage access is denied
    }
    return {
        root: {
            position: 'absolute',
            height: '100%',
            zIndex: 99999,
            userSelect: 'none',
            background: isUsingDarkScheme ? '#000' : theme.palette.background.paper,
            left: 0,
            top: 0,
            '@media (prefers-color-scheme: dark)': {
                background: isUsingSystemScheme ? '#000' : theme.palette.background.paper
            }
        },
        fixedRoot: {
            position: 'fixed'
        },
        logo: {
            width: 50,
            minWidth: 50,
            minHeight: 50,
            maxWidth: 50,
            maxHeight: 50,
            marginBottom: theme.spacing(4)
        },
        description: {
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(4),
            color: '#afb4b6'
        },
        hiddenDescription: {
            marginTop: theme.spacing(-1),
            opacity: 0,
            pointerEvents: 'none',
            touchAction: 'none',
            userSelect: 'none'
        },
        textCentered: {
            textAlign: 'center'
        }
    }
})
